import React, { Component } from 'react';
import classNames from 'classnames';
import Header from 'components/Header';
import Footer from 'components/Footer';

import * as commonService from 'services/commonService';

import { userData, orderData } from './UserData';

class UserAccountPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeTab: 1,
			userData: null,
			orderData: null,

			openAddressModal: false,
			selectedAdrs: null,
			openUserEditModal: false,
			userFormData: null,
			userUpdateError: false,
			openDeleteAdrsModal: false
		};

		document.documentElement.scrollTop = 0;
		document.body.scrollTop = 0;
	}
	componentDidMount() {
		commonService.onLoadFunction();

		let id = window.location.hash;
		let activeTab = 1;
		if (id) id = id.substring(1);
		if (id && parseInt(id) === 2) activeTab = 2;
		this.setState({ activeTab });

		let email = localStorage.getItem('email');
		let name = localStorage.getItem('name');
		let phonenumber = localStorage.getItem('phonenumber');

		let userFormData = {
			email,
			name,
			phonenumber
		};

		this.setState({ userData, orderData, userFormData });
	}
	componentDidUpdate() {
		if (this.props.addingAdrs === 'added') {
			this.props.setAddAddressLoader(false);
			this.setState({ openAddressModal: false });
		}
		if (this.props.updatingUserData === 'updated') {
			this.props.setUpdateUserDataLoader(false);
			this.closeUserModal();
		}
		if (this.props.updatingUserData === 'error') {
			this.props.setUpdateUserDataLoader(false);
			this.setState({ userUpdateError: true });
		}
	}

	changeTab = (activeTab) => {
		this.setState({ activeTab });
	};
	orderStatusName = (id) => {
		if (id === 3) {
			return 'Deliverd';
		} else if (id === 2) {
			return 'Dispatched';
		} else if (id === 1) {
			return 'Packing';
		} else {
			return 'Cooking';
		}
	};
	dateFormat = (date) => {
		let date1 = new Date(date);
		if (date) {
			var month = [
				'January',
				'February',
				'March',
				'April',
				'May',
				'June',
				'July',
				'August',
				'September',
				'October',
				'November',
				'December'
			][date1.getMonth()];
			date1 = month + ' ' + date1.getDate();
			return date1;
		}
	};
	closeAdrsModal = () => {
		if (this.props.addingAdrs && this.props.addingAdrs !== 'added') return;
		else this.setState({ openAddressModal: false, selectedAdrs: null, openDeleteAdrsModal: false });
	};
	adrsCanBeSubmitted = () => {
		let { name, phonenumber, address1, address2, pincode } = this.state.selectedAdrs;
		if (name !== '' && phonenumber !== '' && address1 !== '' && address2 !== '' && pincode !== '') return true;
		return false;
	};
	userFormCanBeSubmitted = () => {
		let { name, phonenumber, email } = this.state.userFormData;
		if (name !== '' && phonenumber !== '' && email !== '') return true;
		return false;
	};
	handleChange = (e) => {
		this.setState({ selectedAdrs: { ...this.state.selectedAdrs, [e.target.name]: e.target.value } });
	};
	saveAddress = () => {
		this.closeAdrsModal();
	};
	handleUserDetailsEdit = () => {
		this.setState({
			openUserEditModal: true
		});
	};
	handleUserFormChange = (e) => {
		this.setState({ userUpdateError: false });
		this.setState({ userFormData: { ...this.state.userFormData, [e.target.name]: e.target.value } });
	};
	closeUserModal = () => {
		this.setState({ openUserEditModal: false });
	};
	updateUserData = () => {
		let { userFormData } = this.state;
		if (userFormData) {
			localStorage.setItem('name', userFormData.name);
			localStorage.setItem('email', userFormData.email);
			localStorage.setItem('phonenumber', userFormData.phonenumber);
			this.closeUserModal();
		}
	};
	handleAdrsOpen = (adrs) => {
		this.setState({ selectedAdrs: adrs, openAddressModal: true });
	};
	handleAdrsDelete = (adrs) => {
		this.setState({ selectedAdrs: adrs, openDeleteAdrsModal: true });
	};
	render() {
		const { deletingAdrs, updatingUserData } = this.props;
		const {
			activeTab,
			userData,

			openAddressModal,
			selectedAdrs,
			openUserEditModal,
			userFormData,
			userUpdateError,
			openDeleteAdrsModal
		} = this.state;

		return (
			<div className="userAccount">
				<Header
					link="/myaccount"
					handleOrderClick={this.handleOrderClick}
					hideSlideshow={true}
					hideHeaderBottom={true}
					history={this.props.history}
				/>
				<div className="container px-0 mt-3">
					<ul className="m-0 p-0 menu">
						<li
							className={classNames('py-2', activeTab === 1 && 'active')}
							onClick={() => this.changeTab(1)}
						>
							My Account
						</li>
						<li
							className={classNames('py-2', activeTab === 2 && 'active')}
							onClick={() => this.changeTab(2)}
						>
							Order History
						</li>
					</ul>

					<div className="content">
						{activeTab === 1 && (
							<div className="mt-2 mt-md-3 mb-4 mb-md-5">
								{userFormData && (
									<div className="px-2">
										<div className="userDetails mx-0 mx-md-3 mx-lg-5">
											<h1 className="m-0 mb-1 mb-md-2">
												{userFormData.name}
												<span onClick={this.handleUserDetailsEdit}>
													Edit
													<i className="fa fa-pencil ml-1" />
												</span>
											</h1>
											<h3 className="m-0 mb-1 mb-md-2">+91-{userFormData.phonenumber}</h3>
											<h3 className="m-0 mb-1 mb-md-2">{userFormData.email}</h3>
										</div>

										<div className="row m-0 w-100 mt-4">
											<div className="col-md-6 px-0">
												<div className="newAdrsBlock py-3 py-sm-4 px-4 px-sm-5 mx-0 mx-md-3 mx-lg-5 my-1 my-sm-2 my-md-3">
													<div
														className="block text-center py-4 pointer"
														onClick={() =>
															this.handleAdrsOpen({
																name: '',
																phonenumber: '',
																address1: '',
																address2: '',
																landmark: '',
																pincode: '',
																type: 'new'
															})}
													>
														Add Delivery Address
													</div>
												</div>
											</div>
											{userData &&
												userData.addresses &&
												userData.addresses.length > 0 &&
												userData.addresses.map((adrs, index) => (
													<div className="col-md-6 px-0" key={index}>
														<div className="adrsCard pt-2 pt-md-3 pb-2 mx-0 mx-md-3 mx-lg-5 my-2 my-md-3">
															<div className="d-flex flex-row align-items-start">
																<div className="type">
																	<i className="fa fa-home" />
																</div>
																<div className="d-flex flex-column mx-2 mx-md-3">
																	<h5>{adrs.name}</h5>
																	<p className="m-0">
																		{adrs.address1 && (
																			<span>{adrs.address1}, </span>
																		)}
																		{adrs.address2 && (
																			<span>{adrs.address2}, </span>
																		)}
																		{adrs.landmark && (
																			<span>{adrs.landmark}, </span>
																		)}
																		{adrs.city && <span>{adrs.city.name}, </span>}
																		{adrs.pincode && <span>{adrs.pincode} </span>}
																	</p>
																	{adrs.phonenumber && (
																		<p className="m-0">
																			<span>{adrs.phonenumber} </span>
																		</p>
																	)}

																	<div className="d-flex flex-row align-items-center mt-2 mt-lg-3 actions">
																		<p
																			className="m-0 pointer"
																			onClick={() => this.handleAdrsOpen(adrs)}
																		>
																			Edit
																		</p>
																		<p className="m-0 line">|</p>
																		<p
																			className="m-0 pointer"
																			onClick={() => this.handleAdrsDelete(adrs)}
																		>
																			Delete
																		</p>
																	</div>
																</div>
															</div>
														</div>
													</div>
												))}
										</div>
									</div>
								)}
							</div>
						)}
						{activeTab === 2 && (
							<div className="row m-0 w-100 orders mt-1 mt-sm-2 mt-md-3 mb-4 mb-md-5">
								{orderData &&
									orderData.map((orderItem, index) => (
										<div className="col-lg-6 px-3 my-2 my-lg-3" key={index}>
											<div className="orderCard">
												<div className="py-2 px-2 px-3">
													<div className="d-flex flex-row align-items-start justify-content-between w-100 top mb-2">
														<p className="m-0 name">${orderItem.name}</p>
														<p className="m-0 price">₹{orderItem.price}</p>
													</div>
													<h6>{orderItem.items} items</h6>
												</div>
												<div className="w-100 bottom p-2">
													<div className="d-flex flex-row align-items-center justify-content-between mt-1">
														<p className="m-0 mb-1" style={{ opacity: 0.7 }}>
															{orderItem.date}
														</p>
														<button
															className={
																orderItem.status === 'cancelled' ? 'cancelled' : ''
															}
														>
															{orderItem.status}
														</button>
													</div>
												</div>
											</div>
										</div>
									))}
							</div>
						)}
					</div>
				</div>

				{openAddressModal && (
					<div className="modalOverlay">
						<div className="modalGlass" onClick={this.closeAdrsModal} />
						<div className="siteModal itemModal1">
							<div className="modalContent">
								<div className="header px-2 py-1">
									<button onClick={this.closeAdrsModal}>
										<i className="fa fa-close" />
									</button>
								</div>
								<div className="body p-1">
									<div className="row m-0 justify-content-center">
										<div className="w-100">
											<div className="newAdrsCard">
												<div className="topSection p-2 p-sm-4">
													<div className="mb-0">
														<h6>Add New Delivery Address</h6>
														<p className="note m-0">
															Please enter the accurate address, it will help us to serve
															you Better
														</p>
													</div>
												</div>
												<div className="bottomSection p-2 p-sm-4">
													<div className="form-group text-left">
														<label htmlFor="name">Name your Address</label>
														<input
															type="text"
															className="form-control"
															name="name"
															value={selectedAdrs.name}
															onChange={this.handleChange}
														/>
													</div>
													<div className="form-group text-left">
														<label>Phone Number</label>
														<input
															type="tel"
															className="form-control"
															name="phonenumber"
															value={selectedAdrs.phonenumber}
															onChange={this.handleChange}
														/>
													</div>
													<div className="form-group text-left">
														<label>Door no / Block name</label>
														<input
															type="text"
															className="form-control"
															name="address1"
															value={selectedAdrs.address1}
															onChange={this.handleChange}
														/>
													</div>
													<div className="form-group text-left">
														<label>Building / Apartment name</label>
														<input
															type="text"
															className="form-control"
															name="address2"
															value={selectedAdrs.address2}
															onChange={this.handleChange}
														/>
													</div>
													<div className="form-group text-left">
														<label>Landmark</label>
														<input
															type="text"
															className="form-control"
															name="landmark"
															value={selectedAdrs.landmark}
															onChange={this.handleChange}
														/>
													</div>
													<div className="form-group text-left">
														<label>Pincode</label>
														<input
															type="text"
															className="form-control"
															name="pincode"
															value={selectedAdrs.pincode}
															onChange={this.handleChange}
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="footer">
									<div className="m-2">
										<button
											className="w-100 saveBtn"
											disabled={!this.adrsCanBeSubmitted()}
											onClick={this.saveAddress}
										>
											Save
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				)}
				{openDeleteAdrsModal && (
					<div className="modalOverlay deleteAdrsModal">
						<div className="modalGlass" onClick={this.closeAdrsModal} />
						<div className="siteModal itemModal1">
							<div className="modalContent">
								<div className="header px-2 py-1">
									<button onClick={this.closeAdrsModal}>
										<i className="fa fa-close" />
									</button>
								</div>
								<div className="body p-1">
									<div className="row m-0 justify-content-center py-5">
										<p>Are you sure! You want to delete the address?</p>
									</div>
								</div>
								<div className="footer">
									<div className="m-2">
										<button
											className="w-100 saveBtn"
											disabled={deletingAdrs && deletingAdrs !== 'deleted'}
											onClick={this.updateUserData}
										>
											{deletingAdrs && deletingAdrs !== 'deleted' ? 'Deleting...' : 'Delete'}
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				)}

				{openUserEditModal && (
					<div className="modalOverlay userEditModal">
						<div className="modalGlass" onClick={this.closeUserModal} />
						<div className="siteModal itemModal1">
							<div className="modalContent">
								<div className="header px-2 py-1">
									<button onClick={this.closeUserModal}>
										<i className="fa fa-close" />
									</button>
								</div>
								<div className="body p-1">
									{userFormData && (
										<div className="row m-0 justify-content-center userForm">
											<div className="w-100 px-2">
												<input
													type="text"
													className="form-control mt-2"
													name="name"
													placeholder="Enter name"
													value={userFormData.name}
													onChange={this.handleUserFormChange}
												/>
												<input
													type="text"
													className="form-control mt-3"
													name="phonenumber"
													placeholder="Enter phonenumber"
													value={userFormData.phonenumber}
													onChange={this.handleUserFormChange}
												/>
												<input
													type="text"
													className="form-control mt-3 mb-2"
													name="email"
													placeholder="Enter email"
													value={userFormData.email}
													onChange={this.handleUserFormChange}
												/>
												{userUpdateError && (
													<p className="m-0" style={{ fontSize: 13, color: 'red' }}>
														Enter valid details
													</p>
												)}
											</div>
										</div>
									)}
								</div>
								<div className="footer">
									<div className="m-2">
										<button
											className="w-100 saveBtn"
											disabled={
												!this.userFormCanBeSubmitted() ||
												(updatingUserData && updatingUserData !== 'updated')
											}
											onClick={this.updateUserData}
										>
											{updatingUserData && updatingUserData !== 'updated' ? (
												'Updating...'
											) : (
												'Update'
											)}
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				)}

				<Footer link="/trackorder" hideEmail={true} />
			</div>
		);
	}
}
export default UserAccountPage;
